import React, { createContext, useState, ReactNode } from 'react';
import { GeneralConfigProps } from 'types/GeneralConfigProps';

interface GeneralConfigProviderProps {
	generalConfigs: GeneralConfigProps | null;
	setGeneralConfigs: React.Dispatch<
		React.SetStateAction<GeneralConfigProps | null>
	>;
}

const GeneralConfigContext = createContext<GeneralConfigProviderProps>({
	generalConfigs: null,
	setGeneralConfigs: () => {}
});

interface ContextProps {
	children: ReactNode;
}

export function GeneralConfigProvider({ children }: ContextProps) {
	const [generalConfigs, setGeneralConfigs] =
		useState<GeneralConfigProps | null>(null);

	return (
		<GeneralConfigContext.Provider
			value={{ generalConfigs, setGeneralConfigs }}
		>
			{children}
		</GeneralConfigContext.Provider>
	);
}

export default GeneralConfigContext;
